import { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import { CONSENT_EVENT, CONSENT_KEY, readAnalyticsConsent } from "@/lib/analyticsConsent";
import { stopAnalytics, trackPage } from "@/lib/privateAnalytics";

// Background lifecycle only. Preferences are available through the footer, never a popup.
export const AnalyticsConsent = () => {
  const location = useLocation();
  const [choice, setChoice] = useState(readAnalyticsConsent);
  useEffect(() => {
    const sync = () => {
      const next = readAnalyticsConsent();
      setChoice(next);
      if (next === "denied") stopAnalytics();
    };
    const storage = event => { if (!event.key || event.key === CONSENT_KEY) sync(); };
    sync();
    window.addEventListener(CONSENT_EVENT, sync);
    window.addEventListener("storage", storage);
    window.addEventListener("focus", sync);
    document.addEventListener("visibilitychange", sync);
    return () => {
      window.removeEventListener(CONSENT_EVENT, sync);
      window.removeEventListener("storage", storage);
      window.removeEventListener("focus", sync);
      document.removeEventListener("visibilitychange", sync);
    };
  }, []);
  useEffect(() => {
    if (choice !== "denied") void trackPage().catch(() => {
      // Measurement must never interrupt the visitor's page or form.
      stopAnalytics();
    });
  }, [choice, location.pathname]);
  return null;
};